import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './store/authStore';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ChatbotSettingsPage from './pages/ChatbotSettingsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import InvoicePage from './pages/InvoicePage';
import AdminPage from './pages/AdminPage';
import SubscriptionManagementPage from './pages/SubscriptionManagementPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';

// Components
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  const { getCurrentUser, isAuthenticated, user } = useAuthStore();

  useEffect(() => {
    getCurrentUser();
  }, [getCurrentUser]);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-conditions" element={<TermsConditionsPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          {/* Protected routes */}
          {/* <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chatbot-settings"
            element={
              <ProtectedRoute>
                <ChatbotSettingsPage />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/subscription"
            element={
              <ProtectedRoute>
                <SubscriptionPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <InvoicePage />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/admin"
            element={
              <ProtectedRoute requireAdmin>
                <AdminPage />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/admin/subscriptions"
            element={
              <ProtectedRoute requireAdmin>
                <SubscriptionManagementPage />
              </ProtectedRoute>
            }
          />

          {/* Auth routes with redirect logic */}
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                user?.role === 'admin' ? <Navigate to="/admin/subscriptions" replace /> : <Navigate to="/subscription" replace />
              ) : (
                <LoginPage />
              )
            }
          />
          <Route
            path="/register"
            element={
              isAuthenticated ? (
                user?.role === 'admin' ? <Navigate to="/admin/subscriptions" replace /> : <Navigate to="/subscription" replace />
              ) : (
                <RegisterPage />
              )
            }
          />

          {/* Catch all route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
